import React, { useState, useEffect } from "react";
import "../Styles/Tpoapprove.css";
import { useNavigate } from "react-router-dom";

import {
  FaFilter,
  FaSearch,
  FaEnvelope,
  FaTrash,
} from "react-icons/fa";

import { IoLogoWhatsapp } from "react-icons/io";

import { ToastContainer, toast } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";

import ApiService from "../nhrc_apis/ApiService";

const { AdminAPI } = ApiService;

function Tpoapprove() {

  const navigate = useNavigate();

  const [employees, setEmployees] = useState([]);

  const [searchTerm, setSearchTerm] = useState("");

  const [selectedIds, setSelectedIds] = useState([]);

  const [page, setPage] = useState(1);

  const [sendOptions, setSendOptions] = useState({
    email: false,
    whatsapp: false,
  });

  const recordsPerPage = 10;

  /* =========================================
     FETCH REPRESENTATIVES
  ========================================= */
  useEffect(() => {
    fetchRepresentatives();
  }, []);

  const fetchRepresentatives = async () => {

    try {

      const res = await AdminAPI.getRepresentatives();

      console.log("FULL API RESPONSE:", res);

      console.log("API DATA:", res.data);

      const list = Array.isArray(res.data)
        ? res.data
        : res.data?.data || [];

      console.log("REPRESENTATIVE LIST:", list);

      const formatted = list.map((tpo, index) => {

        console.log("SINGLE REPRESENTATIVE:", tpo);

        return {

          /* =========================================
             IMPORTANT
             USE MEMBERSHIP ID FOR APPROVE/REJECT
          ========================================= */
          id:
            tpo?.member?.membership_id ||
            tpo?.member?.id ||
            tpo?.details?.member_id ||
            index,

          membershipId:
            tpo?.member?.membership_id || "",

          member_id:
            tpo?.details?.member_id || "",

          /* =========================================
             PERSONAL DETAILS
          ========================================= */
          name:
            tpo?.member?.full_name || "",

          email:
            tpo?.member?.email || "",

          Phone:
            tpo?.member?.mobile || "",

          gender:
            tpo?.member?.gender || "",

          dob:
            tpo?.member?.dob || "",

          blood_group:
            tpo?.member?.blood_group || "",

          state:
            tpo?.member?.state || "",

          district:
            tpo?.member?.district || "",

          pincode:
            tpo?.member?.pincode || "",

          profile_pic:
            tpo?.member?.profile_pic || "",

          role:
            tpo?.member?.role || "",

          candidate_type:
            tpo?.member?.candidate_type || "",

          whatsapp_notification:
            tpo?.member?.whatsapp_notification || false,

          created_at:
            tpo?.member?.created_at || "",

          approved_at:
            tpo?.member?.approved_at || "",

          rejected_at:
            tpo?.member?.rejected_at || "",

          /* =========================================
             STATUS
          ========================================= */
          Status:
            (
              tpo?.member?.status || "pending"
            ).toLowerCase(),

          /* =========================================
             REPRESENTATIVE DETAILS
          ========================================= */
          Designation:
            tpo?.details?.designation || "Representative",

          college_name:
            tpo?.details?.college_name || "",

          department:
            tpo?.details?.department || "",

          university_name:
            tpo?.details?.university_name || "",

          university_address:
            tpo?.details?.university_address || "",

          official_mail_id:
            tpo?.details?.official_mail_id || "",

          mobile_number:
            tpo?.details?.mobile_number || "",

          college_code:
            tpo?.details?.college_code || "",

          representative_state:
            tpo?.details?.state || "",

          representative_district:
            tpo?.details?.district || "",

          representative_pincode:
            tpo?.details?.pincode || "",

          experience:
            tpo?.details?.experience || "",

          /* =========================================
             RAW DATA
          ========================================= */
          fullData: tpo,
        };
      });

      console.log("FORMATTED REPRESENTATIVES:", formatted);

      setEmployees(formatted);

    } catch (err) {

      console.error("FETCH ERROR:", err);

      if (err.response) {
        console.log("ERROR RESPONSE:", err.response);
        console.log("ERROR DATA:", err.response.data);
      }

      toast.error("Failed to load representatives");
    }
  };

  /* =========================================
     SEARCH
  ========================================= */
  const filtered = employees.filter((emp) => {

    const term = searchTerm.toLowerCase();

    return (

      emp.name.toLowerCase().includes(term) ||

      emp.Designation.toLowerCase().includes(term) ||

      emp.Phone.toLowerCase().includes(term) ||

      emp.Status.toLowerCase().includes(term) ||

      emp.college_name.toLowerCase().includes(term) ||

      emp.university_name.toLowerCase().includes(term)
    );
  });

  /* =========================================
     PAGINATION
  ========================================= */
  const paginated = filtered.slice(
    (page - 1) * recordsPerPage,
    page * recordsPerPage
  );

  const totalPages =
    Math.ceil(filtered.length / recordsPerPage) || 1;

  /* =========================================
     SELECT
  ========================================= */
  const toggleSelectAll = (e) => {

    if (e.target.checked) {

      setSelectedIds(
        paginated.map((emp) => emp.id)
      );

    } else {

      setSelectedIds([]);
    }
  };

  const toggleSelect = (id) => {

    setSelectedIds((prev) =>
      prev.includes(id)
        ? prev.filter((x) => x !== id)
        : [...prev, id]
    );
  };

  const isAllSelected =
    paginated.length > 0 &&
    paginated.every((emp) =>
      selectedIds.includes(emp.id)
    );

  /* =========================================
     UPDATE STATUS UI
  ========================================= */
  const updateStatusUI = (ids, status) => {

    setEmployees((prev) =>
      prev.map((emp) =>
        ids.includes(emp.id)
          ? {
              ...emp,
              Status: status,
            }
          : emp
      )
    );
  };

  /* =========================================
     APPROVE
  ========================================= */
  const handleApprove = async () => {

    if (!selectedIds.length) {

      toast.error("Select records");

      return;
    }

    try {

      /* =========================================
         API CALL USING MEMBERSHIP ID
      ========================================= */
      await Promise.all(
        selectedIds.map((membershipId) =>
          AdminAPI.approveMember(membershipId)
        )
      );

      /* =========================================
         UPDATE TABLE STATUS IMMEDIATELY
      ========================================= */
      updateStatusUI(selectedIds, "approved");

      toast.success("Approved successfully");

      setSelectedIds([]);

    } catch (err) {

      console.error("APPROVE ERROR:", err);

      toast.error("Approve failed");
    }
  };

  /* =========================================
     REJECT
  ========================================= */
  const handleReject = async () => {

    if (!selectedIds.length) {

      toast.error("Select records");

      return;
    }

    try {

      /* =========================================
         API CALL USING MEMBERSHIP ID
      ========================================= */
      await Promise.all(
        selectedIds.map((membershipId) =>
          AdminAPI.rejectMember(membershipId)
        )
      );

      /* =========================================
         UPDATE TABLE STATUS IMMEDIATELY
      ========================================= */
      updateStatusUI(selectedIds, "rejected");

      toast.success("Rejected successfully");

      setSelectedIds([]);

    } catch (err) {

      console.error("REJECT ERROR:", err);

      toast.error("Reject failed");
    }
  };

  /* =========================================
     DELETE
  ========================================= */
  const handleDeleteSelected = async () => {

    if (!selectedIds.length) {

      toast.warning("Select records");

      return;
    }

    try {

      await Promise.all(
        selectedIds.map((id) =>
          AdminAPI.deleteMember(id)
        )
      );

      setEmployees((prev) =>
        prev.filter(
          (emp) => !selectedIds.includes(emp.id)
        )
      );

      setSelectedIds([]);

      toast.success("Deleted successfully");

    } catch (err) {

      console.error(err);

      toast.error("Delete failed");
    }
  };

  /* =========================================
     SEND MESSAGE
  ========================================= */
  const handleSendMessages = () => {

    if (!selectedIds.length) {

      toast.error("Select records");

      return;
    }

    const channels = [];

    if (sendOptions.email)
      channels.push("Email");

    if (sendOptions.whatsapp)
      channels.push("WhatsApp");

    if (!channels.length) {

      toast.error("Select channel");

      return;
    }

    toast.success(
      `Sent via ${channels.join(", ")}`
    );
  };

  return (

    <div className="empview-container">

      <ToastContainer />

      {/* HEADER */}
      <div className="empview-header-bar">
        <h2>Representative Approve</h2>
      </div>

      {/* ACTION BAR */}
      <div className="empview-action-bar">

        <button className="empview-filter-btn">
          <FaFilter /> Filter
        </button>

        <div className="empview-search-box">

          <FaSearch />

          <input
            value={searchTerm}
            onChange={(e) =>
              setSearchTerm(e.target.value)
            }
            placeholder="Search..."
          />
        </div>

        <button
          onClick={handleDeleteSelected}
          className="empview-delete-btn"
        >
          <FaTrash /> Delete
        </button>
      </div>

      {/* TOOLBAR */}
      <div className="empview-toolbar">

        <label>
          {employees.length} Representatives
        </label>

        <label>

          <input
            type="checkbox"
            checked={sendOptions.email}
            onChange={() =>
              setSendOptions((p) => ({
                ...p,
                email: !p.email,
              }))
            }
          />

          <FaEnvelope /> Email
        </label>

        <label>

          <input
            type="checkbox"
            checked={sendOptions.whatsapp}
            onChange={() =>
              setSendOptions((p) => ({
                ...p,
                whatsapp: !p.whatsapp,
              }))
            }
          />

          <IoLogoWhatsapp /> WhatsApp
        </label>

        <button
          onClick={handleSendMessages}
          className="empview-send-btn"
        >
          Send
        </button>

        <button
          onClick={handleApprove}
          className="empview-download-btn"
        >
          Approve
        </button>

        <button
          onClick={handleReject}
          className="empview-download-btn"
        >
          Reject
        </button>
      </div>

      {/* TABLE */}
      <div className="empview-table-container">

        <table className="empview-table table table-hover">

          <thead>

            <tr>

              <th>
                <input
                  type="checkbox"
                  onChange={toggleSelectAll}
                  checked={isAllSelected}
                />
              </th>

              <th>Name</th>

              <th>Designation</th>

              <th>Phone</th>

              <th>Status</th>

              <th>Actions</th>

            </tr>

          </thead>

          <tbody>

            {paginated.length > 0 ? (

              paginated.map((emp) => (

                <tr key={emp.id}>

                  <td>

                    <input
                      type="checkbox"
                      checked={selectedIds.includes(
                        emp.id
                      )}
                      onChange={() =>
                        toggleSelect(emp.id)
                      }
                    />

                  </td>

                  <td>{emp.name}</td>

                  <td>{emp.Designation}</td>

                  <td>{emp.Phone}</td>

                  <td
                    style={{
                      color:
                        emp.Status === "approved"
                          ? "green"
                          : emp.Status === "rejected"
                          ? "red"
                          : "orange",

                      fontWeight: "bold",
                    }}
                  >
                    {emp.Status}
                  </td>

                  <td>

                    <button
                      className="empview-view-btn"
                      onClick={() =>
                        navigate(
                          "/dashboard/TpoapproveView",
                          {
                            state: {
                              membershipId:
                                emp.membershipId,

                              representativeData:
                                emp,
                            },
                          }
                        )
                      }
                    >
                      View Details
                    </button>

                  </td>

                </tr>
              ))

            ) : (

              <tr>

                <td
                  colSpan="6"
                  className="text-center"
                >
                  No records found
                </td>

              </tr>
            )}

          </tbody>
        </table>
      </div>

      {/* PAGINATION */}
      <div className="empview-pagination">

        <button
          onClick={() => setPage(page - 1)}
          disabled={page === 1}
        >
          Previous
        </button>

        <span>
          Page {page} of {totalPages}
        </span>

        <button
          onClick={() => setPage(page + 1)}
          disabled={page === totalPages}
        >
          Next
        </button>
      </div>
    </div>
  );
}

export default Tpoapprove;